(function ($) {
	/*
	* This portlet code adds in support for drag and drop and makes heavy use of groupbox events for 
	* manipulating individual portlets. The portlet code below has nothing to do with actual persistence
	* of the portlets state. It provides an event (portletsavepreferences) that is triggered when state 
	* is updated that can then be serialized and sent back to the server for persistence. This code has 
	* nothing to do though with restoring state, that occurs server side in rendering the portlets.
	*/
	$.fn.initPortlets = function () {

		/* HOT FIX for IE 9 for jquery sortable source http://forum.jquery.com/topic/jquery-ui-sortable-and-draggable-do-not-work-in-ie9 */
		var a = $.ui.mouse.prototype._mouseMove;
		$.ui.mouse.prototype._mouseMove = function (b) {
			if ($.browser.msie && document.documentMode >= 9) {
				b.button = 1;
			}
			a.apply(this, [b]);
		};
		/*******************/
		/* This handles interaction between the individual portlets (and their groupbox sub control)
		* this in turn exposes a few additional events 
		* such as: portletupdated, portletcollapse, portletexpand, portletremove, portletadd
		* The detailPageSidebar then binds to these events to update its visual state
		*/
		return this.each(function () {
			$(this)
				.sortable({
					cancel: '.groupboxControls, .groupboxBody',
					helper: 'clone',
					items: 'div.portlet',
					update: function (evt, ui) {
						$(this).trigger('portletupdated');
					},
					change: function () {
						$(this).trigger('portletupdatelayout');
					},
					start: function (evt, ui) {
						$(this).addClass('portletSorting');
						$('<div>&nbsp;</div>').css('height', ($(ui.helper).find('div.groupbox').innerHeight() - 0) + 'px').appendTo(ui.placeholder);

						//$(this).trigger('portletupdatelayout');
						//$(ui.placeholder).css({ 'background': 'pink', 'visibility': 'visible' });
					},
					beforeStop: function () {
						$(this).removeClass('portletSorting');

						//$(this).trigger('portletupdatelayout');
					},
					stop: function () {
						$(arguments[1].item).trigger('sortingStopped');
					},
					opacity: 0.75
				})
				.bind('groupboxexpand', function (evt, force) {
					var $portlet = $(evt.target).closest('.portlet');
					var kls = $portlet.hasClass('expand-to-full') ? 'full' : 'expanded';
					$portlet[arguments.length == 2 ? (force === true ? 'addClass' : 'removeClass') : 'toggleClass'](kls);
					$(this).trigger('portletexpand', [{ id: $portlet.attr('id'), expanded: $portlet.hasClass(kls)}]);
				})
				.bind('groupboxclose', function (evt) {
					var that = this;
					$(evt.target).closest('.portlet')
						.fadeOut(function () {
							$(this).addClass('portletClosed');
							$(that).trigger('portletremove', [{ id: $(this).attr('id')}]);
						});
				})
				.bind('groupboxcollapse', function (evt, ui) {
					var $portlet = $(evt.target).closest('.portlet');
					$(this).trigger('portletcollapse', [{ id: $portlet.attr('id'), collapsed: ui.collapsed}]);
				})
				.bind('portletactivate', function (evt, ui) {
					var that = this;
					$('#' + ui.id)
						.removeClass('portletClosed')
						.find('div.groupbox')
							.removeClass('groupboxCollapsed')
						.end()
						.fadeIn(function () {
							$(that)
								.trigger('portletadd', [ui]);
						});
				})
				.bind('portletstatechanged portletupdated portletexpand portletremove portletcollapse portletadd', function () {
					var preferences = [];
					$('> div.portlet', this).each(function () {
						var $groupbox = $('> div.groupbox', this);
						preferences.push({ Id: $(this).attr('id'),
							Collapsed: $groupbox.hasClass('groupboxCollapsed'),
							Closed: $(this).hasClass('portletClosed'),
							Expanded: $(this).hasClass($(this).hasClass('expand-to-full') ? 'full' : 'expanded')
						});
					});
					$(this)
						.trigger('portletsavepreferences', [preferences])
						.trigger('portletupdatelayout');
				})
				.bind('portletupdatelayout', function () {
					var portlets = $(this).find('div.portlet').removeClass('rightColumn');
					var po = $(this).offset();
					portlets.each(function () {
						if ($(this).offset().left > (po.left + 50)) {
							$(this).addClass('rightColumn');
						}
					});
				});
		}).trigger('portletupdatelayout');
	};
})(jQuery);